import Immutable from 'immutable';
import HoldsConstants from '../../constants/HoldsConstants';
import BorrowingConstants from '../../constants/BorrowingConstants';
import _ from 'lodash';

const initialState = Immutable.Map({
  fetching: false,
  items: Immutable.List(),
  displayQuantity: 25,
  numItemsShowing: 25,
  summary: Immutable.Map(),
  holdsTransactions: Immutable.Map(),
  pagination: Immutable.Map()
});


export default function holds(state = initialState, action) {
  switch (action.type) {
    case HoldsConstants.FETCH_HOLDS_REQUEST:
      return state.mergeDeep({
        fetching: true
      });

    case HoldsConstants.FETCH_HOLDS_SUCCESS: {
      const holdsData = action.payload.borrowing.holds || {};
      return state
        .set('items', Immutable.fromJS(holdsData.items))
        .mergeDeep({
          numItemsShowing: Math.min(holdsData.items.length, state.get('displayQuantity')),
          summary: action.payload.borrowing.summaries.holds,
          pagination: holdsData.pagination,
          fetching: false
        });
    }
    case BorrowingConstants.FETCH_SUMMARIES_SUCCESS:
      return state.mergeDeep({ summary: _.get(action, 'payload.borrowing.holds.summary', {}) });
    case HoldsConstants.CANCEL_HOLD_REQUEST: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.mergeIn(['holdsTransactions', id], { isCancelling: true })
        );
      });
    }
    case HoldsConstants.CANCEL_HOLD_SUCCESS:
    case HoldsConstants.CANCEL_HOLD_FAILURE: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.deleteIn(['holdsTransactions', id, 'isCancelling'])
        );
      });
    }

    case HoldsConstants.UPDATE_HOLDS_EXPIRY_REQUEST: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.mergeIn(['holdsTransactions', id], { isUpdatingExpiryDate: true })
        );
      });
    }
    case HoldsConstants.UPDATE_HOLDS_EXPIRY_SUCCESS:
    case HoldsConstants.UPDATE_HOLDS_EXPIRY_FAILURE: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.deleteIn(['holdsTransactions', id, 'isUpdatingExpiryDate'])
        );
      });
    }

    case HoldsConstants.UPDATE_PAUSE_HOLDS_DATE_REQUEST: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.mergeIn(['holdsTransactions', id], { isUpdatingPauseDate: true })
        );
      });
    }
    case HoldsConstants.UPDATE_PAUSE_HOLDS_DATE_SUCCESS:
    case HoldsConstants.UPDATE_PAUSE_HOLDS_DATE_FAILURE: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.deleteIn(['holdsTransactions', id, 'isUpdatingPauseDate'])
        );
      });
    }

    case HoldsConstants.UPDATE_PAUSE_HOLDS_REQUEST: {
      const key = action.suspended.status ? 'isPausing' : 'isResuming';
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.mergeIn(['holdsTransactions', id], { [key]: true })
        );
      });
    }
    case HoldsConstants.UPDATE_PAUSE_HOLDS_SUCCESS:
    case HoldsConstants.UPDATE_PAUSE_HOLDS_FAILURE: {
      const key = action.suspended.status ? 'isPausing' : 'isResuming';
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.deleteIn(['holdsTransactions', id, key])
        );
      });
    }

    case HoldsConstants.UPDATE_PICKUP_LOCATION_REQUEST: {
      return state.withMutations(newState => {
        newState.mergeIn(['holdsTransactions', action.holdId], { isUpdatingPickupLocation: true });
      });
    }
    case HoldsConstants.UPDATE_PICKUP_LOCATION_SUCCESS:
    case HoldsConstants.UPDATE_PICKUP_LOCATION_FAILURE: {
      return state.withMutations(newState => {
        newState.deleteIn(['holdsTransactions', action.holdId, 'isUpdatingPickupLocation']);
      });
    }

    case HoldsConstants.CANCEL_HOLD_REQUEST: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.mergeIn(['holdsTransactions', id], { isCancelling: true })
        );
      });
    }
    case HoldsConstants.CANCEL_HOLD_SUCCESS:
    case HoldsConstants.CANCEL_HOLD_FAILURE: {
      return state.withMutations(newState => {
        action.holdIds.forEach(id =>
          newState.deleteIn(['holdsTransactions', id, 'isCancelling'])
        );
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/borrowing/HoldsReducer.js